// The Rate Bands roster filters, kept out of the page so they can be run in a
// test rather than matched as source.

export const ROSTER_FILTERS = [
  { id: 'all',        label: 'Everyone' },
  { id: 'unassigned', label: 'No band' },
  { id: 'recent',     label: 'Changed in 90 days' },
];

const RECENT_DAYS = 90;

const haystack = (p) => [
  p.first_name, p.last_name, p.preferred_name, p.rate_band, p.resource_type_name, p.team_name, p.designation,
].filter(Boolean).join(' ').toLowerCase();

/**
 * The roster rows to show for `filter` and `search`. `now` is injectable so
 * "changed in the last 90 days" can be asserted against a fixed date.
 */
export function filterRoster(rows, filter = 'all', search = '', now = new Date()) {
  const cutoff = new Date(now.getTime() - RECENT_DAYS * 86400000);
  const q = (search || '').trim().toLowerCase();
  return rows.filter(p => {
    if (filter === 'unassigned' && !p.unassigned) return false;
    if (filter === 'recent') {
      if (!p.last_changed_at) return false;
      // audit_trail stamps 'YYYY-MM-DD HH:MM:SS' (UTC); make it parseable everywhere.
      if (new Date(p.last_changed_at.replace(' ', 'T') + (p.last_changed_at.endsWith('Z') ? '' : 'Z')) < cutoff) return false;
    }
    if (q && !haystack(p).includes(q)) return false;
    return true;
  });
}
